import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { add } from 'date-fns'
import { cookieKeys, localStorageKeys } from 'lib/consts/browserStorage'
import { getLSItem } from 'lib/helpers/getLSItem/getLSItem'
import { qsSchema } from 'lib/zod'

export const getStoredBusinessId = (): string | null => {
  const cookieBusinessId = qsSchema.parse(getCookie(cookieKeys.businessId))

  return cookieBusinessId || getLSItem(localStorageKeys.businessId)
}

export const setStoredBusinessId = (businessId: string): void => {
  window.localStorage.setItem(localStorageKeys.businessId, businessId)
  setCookie(cookieKeys.businessId, businessId, { expires: add(new Date(), { years: 1 }) })
}

export const clearStoredBusinessId = (): void => {
  window.localStorage.removeItem(localStorageKeys.businessId)
  deleteCookie(cookieKeys.businessId)
}
